import React, { useEffect, useState } from "react";
import "./CounterView.scss";
import ReturnHome from "../Components/ReturnHome";
import { useNavigate } from "react-router";
import viewNavigate from "../Utils/viewNavigate";
import useIdle from "../Hooks/useIdle";
const CounterView = (props) => {
  let navigate = useNavigate();
  const isIdle = useIdle();
  const [num, setNum] = useState(3);
  useEffect(() => {
    setTimeout(() => {
      if (num > 0) {
        setNum(num - 1);
      } else {
        viewNavigate(navigate, "/QuizQuestion/0");
      }
    }, 1000);
  }, [num]);
  return (
    <div className="counter-container">
      <p className="counter-text">{num}</p>
      <div className="return-home-holder-counter">
        <ReturnHome
          onClick={() => {
            viewNavigate(navigate, "/");
          }}
        />
      </div>
      {/* {props.responses.map((elem) => (
        <>
          {question["Knowledge Piece Image"].endsWith(".png") ||
          question["Knowledge Piece Image"].endsWith(".jpg") ? (
            <img style={{ display: "none" }} src={question["Knowledge Piece Image"]} alt="Ultrasound Image" />
          ) : (
            <video loop={true} autoPlay={true} muted={true}>
              <source
                src={question["Knowledge Piece Image"]}
                type={`video/${question["Knowledge Piece Image"].slice(-3)}`}
              />
            </video>
          )}
          {question["Question Image"].endsWith(".png") ||
          question["Question Image"].endsWith(".jpg") ? (
            <img src={question["Question Image"]} alt="Ultrasound Image" />
          ) : (
            <video style={{ display: "none" }} loop={true} autoPlay={true} muted={true}>
              <source
                src={question["Question Image"]}
                type={`video/${question["Question Image"].slice(-3)}`}
              />
            </video>
          )}
        </>
      ))} */}
    </div>
  );
};

export default CounterView;
